import getLoyaltyAccountTier from 'loyalty/selectors/getLoyaltyAccountTier'

function getLoyaltyIsInfiniteAccountTier(state: App.State): boolean {
  return getLoyaltyAccountTier(state) === 'infinite'
}

export default getLoyaltyIsInfiniteAccountTier
